import { Controller } from "@hotwired/stimulus"

// Submits the backtest form via fetch and swaps the rendered results
// partial into the results target. Server returns HTML on success
// (the _results.html.erb partial) and JSON {error: …} with 4xx/5xx
// status on failure.
export default class extends Controller {
  static targets = ["form", "submit", "status"]
  // Must match the REGISTERED identifier (predict-backtest-results), not the
  // pre-port name: Stimulus derives both the data attribute it looks for and
  // the accessor below from this string. Declaring "backtest-results" meant it
  // hunted for a data-predict-backtest-form-backtest-results-outlet that the
  // view never emits, so every successful submit threw "Missing outlet
  // element" instead of swapping the results in.
  static outlets = ["predict-backtest-results"]
  static values  = { url: String }

  async submit(event) {
    event.preventDefault()
    this.lockSubmit("Running…")

    const formData = new FormData(this.formTarget)

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": this.csrfToken(),
          "Accept": "text/html"
        },
        credentials: "same-origin"
      })

      if (response.ok) {
        const html = await response.text()
        this.predictBacktestResultsOutlet.replace(html)
        this.statusTarget.textContent = "Done."
      } else {
        const message = await this.readError(response)
        this.statusTarget.textContent = `Error: ${message}`
      }
    } catch (err) {
      this.statusTarget.textContent = `Network error: ${err.message}`
    } finally {
      this.unlockSubmit()
    }
  }

  async readError(response) {
    try {
      const j = await response.json()
      return j.error || `HTTP ${response.status}`
    } catch {
      return `HTTP ${response.status}`
    }
  }

  lockSubmit(msg) {
    this.submitTarget.disabled = true
    this.statusTarget.textContent = msg
  }

  unlockSubmit() {
    this.submitTarget.disabled = false
  }

  csrfToken() {
    const el = document.querySelector('meta[name="csrf-token"]')
    return el ? el.content : ""
  }
}
